import { render, staticRenderFns } from "./IconSvgJobs.vue?vue&type=template&id=b3080b0a&scoped=true&"
import script from "./IconSvgJobs.vue?vue&type=script&lang=js&"
export * from "./IconSvgJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3080b0a",
  null
  
)

export default component.exports